export enum SubmitSuccessEnum {
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED'
}
